"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var regx_1 = __importDefault(require("regx"));
/**
 * Disable all remote-content in styles, and replace images
 * with the given image URL.
 *
 * Non-image URLs that are replaced will no longer be valid, and ignored.
 * Dirty, but that's what we want.
 */
function blockRemoteContentInStyle($, replacementImageUrl) {
    // <style> tags
    $('style').each(function (_, styleEl) {
        // We would have used .text() here, but there's a bug on script and style tags
        // https://github.com/cheeriojs/cheerio/issues/1050
        var styleText = $(styleEl).html() || '';
        var hasRemoteUrls = REG_STYLE_REMOTE_URLS.test(styleText);
        if (hasRemoteUrls) {
            var replacedText = replaceUrlsInStyle(styleText, replacementImageUrl);
            $(styleEl).text(replacedText);
        }
    });
    // <div style="..."> attributes
    $('[style]').each(function (_, styledEl) {
        var styleText = $(styledEl).attr('style');
        if (!styleText) {
            return;
        }
        var hasRemoteUrls = REG_STYLE_REMOTE_URLS.test(styleText);
        if (hasRemoteUrls) {
            var replacedText = replaceUrlsInStyle(styleText, replacementImageUrl);
            $(styledEl).attr('style', replacedText);
        }
    });
}
// https://regex101.com/r/f2SYlc/4
// Matches remote URLs in a style tag
var REG_STYLE_REMOTE_URLS = regx_1.default('gi')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  (\n\n    (?:\n\n      // Attributes URLs, which always start with: url(\n      url(\n\n      |\n\n      // Or @import statement, with optional url() syntax\n      (?:@imports*)(?:url()?\n\n    )\n\n    [\"']?\n  )\n\n  // Ignore data URLs, or cid attachments\n  (?!data:|cid:)\n\n  // Capture URL value\n  (\n\n    // Protocol\n    (?:w*:)\n\n    // Rest of the url\n    [^'\")]*\n\n  )\n"], ["\n  (\n\n    (?:\n\n      // Attributes URLs, which always start with: url(\n      url\\(\n\n      |\n\n      // Or @import statement, with optional url() syntax\n      (?:@import\\s*)(?:url\\()?\n\n    )\n\n    [\"']?\n  )\n\n  // Ignore data URLs, or cid attachments\n  (?!data:|cid:)\n\n  // Capture URL value\n  (\n\n    // Protocol\n    (?:\\w*:)\n\n    // Rest of the url\n    [^'\"\\)]*\n\n  )\n"])));
function replaceUrlsInStyle(styleText, replacement) {
    return styleText.replace(REG_STYLE_REMOTE_URLS, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function (match) {
        var _a = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _a[_i - 1] = arguments[_i];
        }
        var _b = __read(_a, 2), prefix = _b[0], capturedUrl = _b[1];
        // The original match is `${prefix}${capturedUrl}`
        return "" + prefix + replacement;
    });
}
exports.default = blockRemoteContentInStyle;
var templateObject_1;
